import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Copy, CheckCircle2, HeartHandshake } from 'lucide-react';
export function Donate() {
  const [copied, setCopied] = useState(false);
  const accountNumber = '5080135317';
  const handleCopy = () => {
    navigator.clipboard.writeText(accountNumber);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <section id="donate" className="py-20 md:py-32 bg-gold text-midnight overflow-hidden relative" data-id="element-99" data-mp="3cfrg2f2iwl72">
      {/* Decorative background text */}
      <div className="absolute -top-20 -right-20 w-96 h-96 bg-white/20 rounded-full blur-3xl pointer-events-none" data-id="element-100" data-mp="3h7iyu3fftmmn" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-101" data-mp="32fh3mwobbhsy">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-midnight text-ivory rounded-[2rem] md:rounded-[3rem] p-6 sm:p-8 md:p-16 relative shadow-2xl" data-id="element-102" data-mp="37h6f2dfg5xhk">
          {/* Rotated Badge */}
          <div className="absolute -top-4 right-4 md:-top-6 md:-right-10 bg-white text-midnight font-bold px-4 md:px-6 py-2 md:py-3 rounded-full rotate-12 shadow-xl border-2 md:border-4 border-midnight text-[10px] md:text-sm tracking-widest uppercase flex items-center gap-1.5 md:gap-2 whitespace-nowrap" data-id="element-103" data-mp="2pxnvx5jz1zyz">
            <HeartHandshake className="w-3 h-3 md:w-4 md:h-4 text-gold" data-id="element-104" data-mp="2c82isbsuseyv" />
            Partner With Us
          </div>

          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center relative z-10" data-id="element-105" data-mp="27a0yjnjoy9lt">
            <div data-id="element-106" data-mp="2lyezfsxjrnzq">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-xs font-bold tracking-widest uppercase mb-6 md:mb-8 text-gold" data-id="element-107" data-mp="2lyx4nf26tcjs">
                Partnership
              </div>
              <h3 className="text-4xl sm:text-5xl md:text-6xl font-display font-bold tracking-tighter mb-6" data-id="element-108" data-mp="1ohpz63o8wtsg">
                Support the <br data-id="element-109" data-mp="2e6dmmv2esctz" />
                <span className="font-serif italic font-medium text-gold" data-id="element-110" data-mp="2e52i2t15311t">
                  Vision
                </span>
              </h3>
              <p className="text-base md:text-lg text-ivory/80 font-medium leading-relaxed mb-8" data-id="element-111" data-mp="2i52uk84oh268">
                Your generous donations help us continue our outreaches,
                retreats, and missions to raise Kingdom Giants and support those
                in need across communities.
              </p>
              <p className="text-sm font-bold tracking-widest uppercase text-gold" data-id="element-112" data-mp="1z8l9g9kc40iy">
                Every gift fuels a soul.
              </p>
            </div>

            <div className="bg-white text-midnight p-6 sm:p-8 md:p-10 rounded-[1.5rem] md:rounded-[2rem] shadow-xl md:rotate-1" data-id="element-113" data-mp="2463a7co779fv">
              <div className="space-y-6 md:space-y-8" data-id="element-114" data-mp="3fmtid1c6mbc4">
                <div data-id="element-115" data-mp="3fm1lzoarg9ks">
                  <p className="text-xs font-bold uppercase tracking-widest text-charcoal/50 mb-2" data-id="element-116" data-mp="3foxkbdqit09r">
                    Bank
                  </p>
                  <p className="text-xl md:text-2xl font-display font-bold" data-id="element-117" data-mp="18z420cmzk1kk">
                    Fidelity Bank
                  </p>
                </div>
                <div data-id="element-118" data-mp="141kkn3uzr8oe">
                  <p className="text-xs font-bold uppercase tracking-widest text-charcoal/50 mb-2" data-id="element-119" data-mp="z8recbjvjsa7">
                    Account Name
                  </p>
                  <p className="text-lg md:text-xl font-display font-bold break-words" data-id="element-120" data-mp="u952o6jp2k3i">
                    CAMP DAVID PRAYER TEAM
                  </p>
                </div>
                <div data-id="element-121" data-mp="l8qdgw3m0kuq">
                  <p className="text-xs font-bold uppercase tracking-widest text-charcoal/50 mb-2" data-id="element-122" data-mp="l7f2ab7u4atl">
                    Account Number
                  </p>
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between bg-midnight/5 p-3 sm:p-2 sm:pr-2 sm:pl-6 rounded-2xl sm:rounded-full mt-2 border-2 border-midnight/10 gap-3 sm:gap-2" data-id="element-123" data-mp="bbc0x7kt4g7p">
                    <span className="text-2xl md:text-3xl font-display font-black tracking-wider text-midnight text-center sm:text-left break-all" data-id="element-124" data-mp="25olebagh4lv8">
                      {accountNumber}
                    </span>
                    <button onClick={handleCopy} className="bg-midnight text-ivory px-5 md:px-6 py-3 rounded-full font-bold text-sm tracking-wide hover:bg-gold hover:text-midnight transition-colors flex items-center justify-center gap-2 active:scale-95 w-full sm:w-auto shrink-0" aria-label="Copy account number" data-id="element-125" data-mp="2inb1c0e01v3v">
                      {copied ? <>
                          <CheckCircle2 className="w-4 h-4" data-id="element-126" data-mp="1l13tmhmefmna" />
                          Copied
                        </> : <>
                          <Copy className="w-4 h-4" data-id="element-127" data-mp="1pxm1hqd1013u" />
                          Copy
                        </>}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}